import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { LimitsPerNbSteps } from '@shared/constants';
import { StepChallenge } from '@shared/factory';
import { StepChallengeVariant1Config } from '@shared/models';
import {
  AmountPipe,
  ProgressWidthPipe,
  RewardPipe,
  SafePipe,
  StepStatusPipe,
} from '@shared/pipes';

@Component({
  selector: 'b2c-progress-section',
  styleUrl: './progress-section.component.scss',
  templateUrl: './progress-section.component.html',
  imports: [
    SafePipe,
    AmountPipe,
    RewardPipe,
    StepStatusPipe,
    ProgressWidthPipe,
  ],
})
export class ProgressSectionComponent extends BaseComponent {
  challenge = input.required<StepChallenge>();
  config = input.required<StepChallengeVariant1Config>();

  public limitsPerNbSteps: LimitsPerNbSteps = {
    oneStep: { start: 0, end: 189 },
    twoStep: { step1: { start: 0, end: 71 }, step2: { start: 86, end: 189 } },
    threeStep: {
      step1: { start: 0, end: 43 },
      step2: { start: 58, end: 116 },
      step3: { start: 132, end: 189 },
    },
  };
}
